import Chatting from './index.vue'

export default Chatting